import React from 'react';

interface AuctionImageProps {
  style?: {};
  imagePath?: string;
}

const AuctionImage: React.FC<AuctionImageProps> = (props) => {
  const [imageUrl] = React.useState(props.imagePath);

  if (!imageUrl) {
    return <></>;
  }

  return <img style={{ ...props.style }} src={`${imageUrl}`} alt="auction" />;
};

export default AuctionImage;
